module.exports = __webpack_public_path__ + "img/vignettes-asso_0000_jouons-pour-un-reve.18438624.jpg";